import React from "react";
import { Link as RLink } from "react-router-dom";
import { Box, FormControl, InputLabel, Link, MenuItem, Paper, Select, TextField, Typography, } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { ButtonLoader } from "frontend/src/ui/button-loader";
import { useDevice } from "frontend/src/domain/devices";
import { useTimetables } from "frontend/src/domain/timetables";
import { paths } from "frontend/src/pages/paths/index";
import { useEditDevice } from "./model.new";
export var DeviceSettings = function (_a) {
    var _b;
    var id = _a.id;
    var device = useDevice(id);
    var edited = useEditDevice({ device: device.data, id: id });
    var timetables = useTimetables();
    var isDisabled = device.isSuccess &&
        !((_b = device.data) === null || _b === void 0 ? void 0 : _b.timetableId) &&
        timetables.isSuccess &&
        timetables.data.length === 0;
    return (React.createElement(Box, { component: Paper, p: 2 },
        React.createElement(Box, { component: "form", mt: 2, onSubmit: edited.submit },
            device.data ? (React.createElement(TextField, { disabled: isDisabled, margin: "none", value: edited.title.value, onChange: edited.title.onChange, fullWidth: true, label: "Название" })) : (React.createElement(Skeleton, null)),
            React.createElement(Box, { mt: 2 },
                isDisabled && (React.createElement(Typography, null,
                    "\u0427\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0438\u0433\u0440\u044B\u0432\u0430\u0442\u044C \u043C\u0443\u0437\u044B\u043A\u0443 \u0441 \u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430, \u0432\u0430\u043C \u043D\u0443\u0436\u043D\u043E \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u0441\u0435\u0442\u043A\u0443 \u0432\u0435\u0449\u0430\u043D\u0438\u044F. \u042D\u0442\u043E \u043C\u043E\u0436\u043D\u043E \u0441\u0434\u0435\u043B\u0430\u0442\u044C",
                    " ",
                    React.createElement(Link, { component: RLink, to: paths.business.owner.timetables.index() }, "\u0437\u0434\u0435\u0441\u044C"),
                    ".")),
                device.data && timetables.data ? (timetables.data.length > 0 && (React.createElement(FormControl, { fullWidth: true },
                    React.createElement(InputLabel, { shrink: true }, "\u0421\u0435\u0442\u043A\u0430 \u0432\u0435\u0449\u0430\u043D\u0438\u044F"),
                    React.createElement(Select, { fullWidth: true, value: edited.timetableId.value, onChange: edited.timetableId.onChange }, timetables.data.map(function (_a) {
                        var id = _a.id, title = _a.title;
                        return (React.createElement(MenuItem, { key: id, value: id }, title));
                    }))))) : (React.createElement(Skeleton, null))),
            React.createElement(Box, { mt: 2 },
                React.createElement(ButtonLoader, { disabled: isDisabled, isLoading: edited.pending, variant: "contained", color: "primary", type: "submit" }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C")))));
};
